import { useState, useEffect } from "react";
import axios from "axios";
import { logSchemas } from "./schemas";
import LogTypeSelector from "./LogTypeSelector";
import LogTable from "./LogTable";
import "./AuditLog.scss";

//MUI

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import DevNav from "../nav/DevNav";

const AuditLog = () => {
  const url = process.env.REACT_APP_DEPPLOYED;
  const [params, setParams] = useState({
    logType: "",
    date: "",
    searchText: "",
    page: 1,
  });
  const [displayedType, setDisplayedType] = useState("");
  const [logs, setLogs] = useState([]);
  const [searchTriggered, setSearchTriggered] = useState(false);
  const [pageAmount,setPageAmount] = useState()

  const buildQuery = (params) => {
    const query = new URLSearchParams();
    if (params.logType) query.append("logType", params.logType);
    if (params.searchText) query.append("logsText", params.searchText);
    if (params.date) query.append("date", params.date);
    if (params.page) query.append("page", params.page);

    return query.toString();
  };

  useEffect(() => {
      fetchLogs();
      setSearchTriggered(false);
    
  }, [params.page, searchTriggered]);

  const fetchLogs = async () => {
    if (!params.logType) {
      return;
    }
    const apiParams = buildQuery(params);
    await axios
      .get(`${url}/logs/?${apiParams}`)
      .then((response) => {
        setLogs(response.data.data);
        setPageAmount(response.data.totalPages)
        setDisplayedType(params.logType);
      })
      .catch((error) => {
        console.error("Error", error);
      });
  };

  const handleParamChange = (event) => {
    const { name, value } = event.target;
    setParams((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePageChange = (newPage) => {
    setParams((prev) => ({
      ...prev,
      page: newPage,
    }));
  };

  const handleSearchClick = () => {
    setParams((prev) => ({
      ...prev,
      page: 1,
    }));
    setSearchTriggered(true);
  };

  return (
    <>
      <DevNav />
      <div className="auditLog">
        <h2>Audit Log</h2>
        <Box
          component="form"
          sx={{ "& > :not(style)": { m: 1, width: "25ch" } }}
          noValidate
          autoComplete="off"
        >
          <LogTypeSelector
            value={params.logType}
            handleTypeChange={handleParamChange}
          />
          <TextField
            sx={{ m: 1, width: 300, background: "white" }}
            id="outlined-basic"
            label="Log text/id"
            variant="outlined"
            name="searchText"
            value={params.searchText}
            onChange={handleParamChange}
          />
          <input
            aria-label="date"
            type="date"
            id="logDate"
            name="date"
            value={params.date}
            onChange={handleParamChange}
          />
        </Box>
        <Button className="searchBtn" onClick={handleSearchClick}>
          Search
        </Button>
        {logs.length > 0 ? (
          <div>
            {/* {console.log(logSchemas[displayedType], logs)} */}
            <LogTable
              schema={logSchemas[displayedType]}
              logs={logs}
              page={params.page}
              pageAmount={pageAmount}
              handlePageChange={handlePageChange}
            />
          </div>
        ) : <p style={{ marginTop: "1rem", color:"black"}}>No logs to display.</p>}
      </div>
    </>
  );
};
export default AuditLog;
